function accountSeeMoreToggler() {
	$(document).on("click", ".seeMoreToggler", function() {
		$(this)
			.siblings(".js-textToggled")
			.toggleClass("is-hided");
		if ($(this).text() == "See more") {
			$(this).text("Hide");
		} else {
			$(this).text("See more");
		}
	});
}